import { InjectionToken } from '@angular/core';
import { MenuItem } from 'primeng/api';

export const MENU_TOKEN = new InjectionToken<Array<MenuItem>>(undefined, {
  providedIn: 'root',
  factory: () => [],
});
